import { StyledHeader } from '@clickcease/cc-client-components-lib'
import { useTranslation } from 'react-i18next'

import { MicrosoftAudienceModalContent } from './MicrosoftAudienceModalContent'
import React from 'react'

export const AudienceConnectInnerForGateway = ({ onClose }: { onClose: () => void }) => {
  const { t } = useTranslation('PMPlatforms')

  return (
    <div style={{ width: '800px', display: 'flex', flexDirection: 'column' }}>
      <StyledHeader css={{ padding: '$8 $8 0px $8' }}>
        {t('microsoft-audience-modal.title')}
      </StyledHeader>
      <MicrosoftAudienceModalContent onOpenChange={onClose} />
    </div>
  )
}
